class ProductOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", (e) => {
      this.querySelector("conditional-details")?.dispatchEvent(
        new CustomEvent("conditional-details:close"),
      );
      this.querySelector(".product-form__option-name").classList.add(
        "product-form__option-name--dirty",
      );
      this.querySelector(".product-form__option-selected-value").innerHTML =
        e.target.dataset.optionValue;
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("product-option")) {
  customElements.define("product-option", ProductOption);
}
